const GATE_NAME_PATTERN = /^(\D*)(\d+)(\D*)$/;

function parseGateName(name: string): [string, number, string] | null {
  const match = name.match(GATE_NAME_PATTERN);
  if (!match) {
    return null;
  }
  return [match[1], parseInt(match[2], 10), match[3]];
}

export function compareGateNames(a: string, b: string): number {
  const cleanA = a.replace(/^\*/, "");
  const cleanB = b.replace(/^\*/, "");

  const parsedA = parseGateName(cleanA);
  const parsedB = parseGateName(cleanB);

  if (parsedA && parsedB) {
    const [prefixA, numA, suffixA] = parsedA;
    const [prefixB, numB, suffixB] = parsedB;

    if (prefixA !== prefixB) {
      return prefixA.localeCompare(prefixB);
    }

    const numDiff = numA - numB;
    if (numDiff !== 0) {
      return numDiff;
    }

    return suffixA.localeCompare(suffixB);
  }

  return cleanA.localeCompare(cleanB);
}
